import React from "react";
import { Helmet } from 'react-helmet';
import Breadcrumb from "../components/Breadcrumb";
import Navbar from "../components/Navbar";
import WorkServices from "../components/WorkServices";
import Footer from "../components/Footer";

const Services = () => {
    return (
        <>
            <Helmet>
                <title>Services | ConnectUs Infoway Pvt. Ltd.</title>
            </Helmet>
            <Navbar />
            <Breadcrumb title="SERVICES" />
            <WorkServices />
            <Footer />
        </>
    );
}

export default Services;
